import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'swiper/swiper-bundle.css'
import '@/assets/css/icomoon/style.css'
import '@/assets/css/public.scss'
import api from '@/assets/js/api'

const app = createApp(App)

app.use(router)
app.use(ElementPlus)
app.config.globalProperties.$http = api

app.mount('#app')
// createApp(App).use(router).mount('#app')
